<mat-card>
  <mat-card-header>
    <mat-card-title></mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <table>
      <thead>
        <tr>
          <th *ngIf="devices && devices.length > 0">{{ 'devices.title' | translate }}</th>
          <th *ngIf="devices && devices.length === 0">{{ 'devices.none' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let device of devices">
          <td>
            {{ device.name }}
            <app-synth [device]="device"></app-synth>
            <app-keyboard [device]="device"></app-keyboard>
            <app-sheet [device]="device"></app-sheet>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card-content>
</mat-card>